import { DISPATCH_ID } from '../../libs/utils/Const';

export const ConfigReducer = (state = { spinner: false, promiseCount: 0, currency: {}, modules: {} }, action) => {
    switch (action.type) {
        case DISPATCH_ID.CONFIG_SET_SPINNER:
            const { promiseCount } = state;
            let count = 0;
            let enable = false;

            if (action.value) {
                count = promiseCount + 1;
                enable = action.value;
            } else {
                count = promiseCount - 1;
            }

            if (count === 0) {
                enable = action.value;
            }

            return Object.assign({}, state, { spinner: enable, promiseCount: count });
        case DISPATCH_ID.CONFIG_CLEAN_REDUCER:
            return Object.assign({}, state, { spinner: false });
        case DISPATCH_ID.CONFIG_SET_CURRENCY:
                return Object.assign({}, state, { currency: action.value });
        case DISPATCH_ID.CONFIG_SET_MODULES:
                return Object.assign({}, state, { modules: action.value });
        default:
            return state;
    }
};